import React from 'react';

const FrontPageTacos = () => {
    return (
        <div className="taco-intro">
            {/* Contenedor de Logos y Título */}
            <div className="taco-intro__logo-container">
                <div className='d-flex align-items-center justify-content-center'>
                    {/* Logo central (ej. La Moderna, ADSL, o la marca patrocinadora) */}
                    <img src="/img/page/xolos-five.png" className="taco-intro__logo" alt="Patrocinador Central" />
                </div>
                
                <p className="taco-intro__text text-uppercase fw-bold mt-4" style={{ color: '#fff', textShadow: '-4px 0 #3a4c98, 0 4px #3a4c98, 4px 0 #3a4c98, 0 -4px #3a4c98' }}>Presentan</p>
                <p className="taco-intro__title text-uppercase fw-black text-center" style={{ color: '#fff', textShadow: '-4px 0 #3a4c98, 0 4px #3a4c98, 4px 0 #3a4c98, 0 -4px #3a4c98' }}>Velocidad taquera</p>
            </div>

            {/* El taco animado que cae y rebota. 
                Usamos la imagen '4.png' asumiendo que es el taco ya con salsa y todo armado */}
            <img src="/img/games/taco/4.png" className="taco-intro__taco" style={{ width: '600px' }} alt="Taco Gigante" />
        </div>
    );
};

export { FrontPageTacos };